export const loginSuccess = () => ({
    type: 'success',
    title: 'Login success',
    message: 'Welcome'
})

export const loginFailure = (error) => ({
    type: 'error',
    title: 'Login error',
    message: error 
})

export const logoutSuccess = () => ({
    type: 'success',
    title: 'Logout success',
    message: 'Bye bye! See you soon!'
})

export const magicLoginSuccess = () => ({
    type: 'success',
    title: 'Magic Login Success',
    message: 'An email has been sent to you.'
})

export const updateCurrentUserSuccess = () => ({
    type: 'success',
    title: 'Profile updated!'
})


// WEBPACK FOOTER //
// ./src/client/features/session/contents/flashes.js